const randomize = require("randomatic");

export default [
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),
    props: {
      filterName: "supplierName_contains",
      label: "Supplier",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/CurrencyFilter"),
    props: {
      filterName: "currency_code_eq",
      label: "Supplier Currency",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),
    props: {
      filterName: "reference_contains",
      label: "Payment Ref",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/DepartmentMultiFilter"),
    props: {
      filterName: "departments_eq",
      label: "Department",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/BrandMultiFilter"),
    props: {
      filterName: "brands_eq",
      label: "Brand",
    },
  },

  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),
    props: {
      filterName: "external_ref_contains",
      label: "Supplier Invoice Number",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/NumberComparatorFilter"),
    props: {
      filterName: "amount",
      label: "Amount",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),
    props: {
      filterName: "iti_reference_contains",
      label: "Itinerary Ref",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),
    props: {
      filterName: "agent_name_contains",
      label: "Agent",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),
    props: {
      filterName: "invoice_no_contains",
      label: "Number",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),
    props: {
      filterName: "client_surname_contains",
      label: "Client",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/HeadOfficeFilter"),
    props: {
      filterName: "headofficeId",
      label: "HeadOffice",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/DatesRangeFilter"),
    props: {
      filterName: "iti_start_date",
      label: "Itinerary start date between",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/DatesRangeFilter"),
    props: {
      filterName: "created_at",
      label: "Created at date between",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/BooleanFilter"),
    props: {
      filterName: "exported_eq",
      label: "Exported",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/BooleanFilter"),
    props: {
      filterName: "posted_eq",
      label: "Posted",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/DatesRangeFilter"),
    props: {
      filterName: "payment_date",
      label: "Payment date between",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/DatesRangeFilter"),
    props: {
      filterName: "service_date",
      label: "Service date between",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () =>
      import("../../shared/list-filters/InternalStatusMultiFilter"),
    props: {
      filterName: "internalStatus_eq",
      label: "Internal Status",
    },
  },
];



// WEBPACK FOOTER //
// ./src/components/gt/finances/purchase-invoice-payments/purchase-invoice-payments-filters.js